// extracted by css-extract-rspack-plugin
export default {"container":"zl1yguoBH1AEll6F","info":"ncshEDDyyQgqcoi3","infoName":"jggcBs4vfU4IVMNh","externalLink":"ReU_3CZ1sW0GuTcF","divider":"xQxExX3yHNsQZr9k","email":"rpGFtfSQ48apMz1s"};